module.exports = __webpack_public_path__ + "static/media/Logo__Lyft.95f0b75a.svg";